import { Typography } from "@material-ui/core";
import ModalProfile from "../../DialogProfile/Modal";
const DoesntFreeAppointmentModal = ({ openModal, onClose , errorMessage}) => {
    return (
        <>
            {openModal &&
                <ModalProfile
                    type='cancel'
                    observation={
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <Typography>
                                {errorMessage}
                            </Typography>
                        </div>
                    }
                    description={''}
                    open={openModal}
                    onClose={onClose}
                    close={true}
                />
            }
        </>
    );
};

export default DoesntFreeAppointmentModal;